import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import { useAuthStore } from '@/stores/authStore';

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    next({ path: to.path });
  } else {
    next();
  }
};


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      return { top: 0, behavior: 'smooth' };
    } 
  },
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: true,
        title: 'Home'
      },
      component: HomeView,
      beforeEnter: filterPath
    },
    {
      path: '/signinregister',
      name: 'signinregister',
      meta: {
        title: 'Sign In or Register',
      },
      component: () => import('@/components/registration/SignInRegister.vue'),
      beforeEnter: (to, from , next) => {
        const store = useAuthStore();
        if (store.authenticated) {
          next({ path: '/' });
        } else {
          filterPath(to, from ,next);
        }
      }
    }, 
    {
      path: '/myorganization',
      name: 'myorganization',
      meta: {
        requiresAuth: true,
        title: 'My Organization',
        breadcrumb: [
          { label: 'My Organization' }
        ]
      },
      component: () => import('../views/organization/MyOrganizationView.vue'),
      beforeEnter: filterPath
    },
    {
      path: '/registration',
      name: 'registration',
      meta: {
        title: 'HEP Registration',
      },
      component: () => import('../views/registration/RegistrationView.vue')
    },
    {
      path: '/organizationregistration',
      name: 'org-registration',
      meta: {
        title: 'Registration New Organization',
        instructions: 'Complete all required fields below to submit the registration.'
      },
      component: () => import('../views/registration/RegisterOrganizationView.vue')
    },
    {
      path: '/organizationregistration/:orgType',
      name: 'hce-registration',
      props: { orgType: '' },
      meta: {
        title: '',
        instructions: 'Complete all required fields below to submit the registration.'
      },
      component: () => import('../views/registration/RegisterOrganizationView.vue')
    },
    {
      path: '/contactregistration/:organizationId',
      name: 'contactregistration',
      props: { organizationId: null },
      meta: {
        title: 'Register Contact with Organzation',
        instructions: 'Complete all required fields below to submit the registration.'
      },
      component: () => import('../views/registration/RegisterContactView.vue')
    },
    {
      path: '/annualreports',
      name: 'annualreports',
      meta: {

        requiresAuth: true,
        title: 'Annual Reports',
        instructions: 'Below is a list of annual reports that need to be completed.',
        breadcrumb: [
          { label: 'Annual Reports' }
        ]
      },
      component: () => import('../views/reporting/AnnualReportsView.vue')
    },
    {
      path: '/annualreports/annualreport',
      name: 'annualreport',
      props: { reportId: null, orgId: null, periodId: null
      },
      meta: {
        title: 'Annual Report Detail',
        instructions: ''
      },
      component: () => import('../modules/hp/views/AnnualReportView.vue')
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        title: 'Unauthorized'
      },
      beforeEnter: filterPath,
      component: () => import('../views/UnauthorizedView.vue')
    },    
    {
      path: '/:catchAll(.*)',
      name: 'notfound',
      component: () => import('../components/NotFound.vue'),
      meta: {
        title: 'Not Found',
      },
      beforeEnter: filterPath
    },
 ]
});

router.beforeEach(async (to, from, next) => {
 handleNavigation();

  function handleNavigation() {
    if (to.meta.requiresAuth) {
      const store = useAuthStore();
      if (!store.authenticated) {
        next({ path: '/signinregister' });
      } else if (to.meta.requiresAdmin && !store.user.isAdminUser) {
          next({ path: '/unauthorized' });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});

export default router;
